/* RAVIN Header V2: switch dark-hero header to white when the light shop
   surface actually reaches the top. Does not touch the 3D navigation menu. */
(()=> {
  const init=()=>{
    const body=document.body;
    if(!body.classList.contains('rv-hv2-dark-hero')) return;
    const sheet=document.querySelector('#MainContent .rvci-sheet');
    const cart=document.querySelector('#MainContent cart-items');
    const hero=document.querySelector('#MainContent .rfl-cart');
    if(!sheet && !cart && !hero) { body.classList.add('rv-hv2-past-hero'); return; }
    let pending=false;
    const update=()=>{
      pending=false;
      const header=document.querySelector('.section-header .header');
      const height=header ? header.getBoundingClientRect().height : 54;
      const limit=height+4;
      const passed=sheet ? sheet.getBoundingClientRect().top<=limit :
        cart ? cart.getBoundingClientRect().top<=limit :
        hero ? hero.getBoundingClientRect().bottom<=limit : false;
      body.classList.toggle('rv-hv2-past-hero',passed);
    };
    const schedule=()=>{ if(pending)return;pending=true;requestAnimationFrame(update); };
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
    update();
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();